// extracted by mini-css-extract-plugin
export var content = "card-gallery-module--content--69488";
export var entry = "card-gallery-module--entry--6e0a1";
export var expanded = "card-gallery-module--expanded--823d0";
export var footerElements = "card-gallery-module--footerElements--e3beb";
export var gallery = "card-gallery-module--gallery--0a0ac";
export var readMore = "card-gallery-module--readMore--3467b";